import { useLocationPhoneNumbers } from 'app/components/location-phone-numbers/useLocationPhoneNumbers'
import { LocationPhoneNumbersComponent } from 'app/components/location-phone-numbers/LocationPhoneNumbersComponent'
import { phoneNumbersValidator } from 'app/components/location-phone-numbers/phoneNumbersValidator'

export default function PhoneNumbers() {
  const props = useLocationPhoneNumbers()
  return <LocationPhoneNumbersComponent {...props} validator={phoneNumbersValidator} />
}
